import React from 'react';
import { Twitter, Linkedin, Github, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: "Platform",
      links: [
        { name: "OnePlace NLQ Engine", href: "#text-to-sql" },
        { name: "OnePlace Tool Management", href: "#tool-management" },
        { name: "OnePlace Agent Builder", href: "#agent-workflows" }
      ]
    },
    {
      title: "Solutions",
      links: [
        { name: "Enterprise Data", href: "#" },
        { name: "Financial Services", href: "#" },
        { name: "Healthcare", href: "#" },
        { name: "Manufacturing", href: "#" }
      ]
    },
    {
      title: "Resources", 
      links: [
        { name: "Documentation", href: "#" },
        { name: "API Reference", href: "#" },
        { name: "Tutorials", href: "#" },
        { name: "Community", href: "#" }
      ]
    },
    {
      title: "Company",
      links: [
        { name: "About Us", href: "#" },
        { name: "Careers", href: "#" },
        { name: "Contact", href: "mailto:support@getoneplace.ai" },
        { name: "Privacy Policy", href: "/privacy/" },
        { name: "Terms of Service", href: "/terms/" }
      ]
    }
  ];

  const socialLinks = [
    { icon: Twitter, href: "#", name: "Twitter" },
    { icon: Linkedin, href: "#", name: "LinkedIn" },
    { icon: Github, href: "#", name: "GitHub" },
    { icon: Mail, href: "#", name: "Email" }
  ];

  return (
    <footer className="bg-[var(--bg-primary)] border-t border-[var(--border-subtle)]">
      <div className="light-full-container">
        <div className="light-content-container">
          <div className="py-16 space-y-12">
            {/* Top Section */}
            <div className="grid grid-cols-1 lg:grid-cols-6 gap-8">
              {/* Brand */}
              <div className="lg:col-span-2 space-y-6">
                <div className="flex items-center gap-3">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_oneplace-redesign/artifacts/rt4rgdof_oneplace_white.png"
                    alt="OnePlace"
                    className="h-6 object-contain"
                  />
                </div>
                <p className="body-small max-w-sm">
                  The Agentic Platform for Data, Knowledge, and Automation. 
                  Unify your enterprise data ecosystem with explainable AI.
                </p>
                <div className="flex gap-4">
                  {socialLinks.map((social, index) => {
                    const IconComponent = social.icon;
                    return (
                      <a
                        key={index}
                        href={social.href}
                        className="p-2 border border-[var(--border-subtle)] light-hover light-transition hover:border-[var(--brand-primary)]"
                        aria-label={social.name}
                      >
                        <IconComponent className="w-5 h-5" />
                      </a>
                    );
                  })}
                </div>
              </div>

              {/* Links Grid */}
              <div className="lg:col-span-4 grid grid-cols-2 md:grid-cols-4 gap-8">
                {footerSections.map((section, index) => (
                  <div key={index} className="space-y-4">
                    <h4 className="heading-3">{section.title}</h4>
                    <ul className="space-y-3">
                      {section.links.map((link, linkIndex) => (
                        <li key={linkIndex}>
                          <a 
                            href={link.href} 
                            className="body-small text-[var(--text-muted)] hover:text-[var(--text-primary)] light-transition"
                          >
                            {link.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-[var(--border-subtle)]"></div>

            {/* Bottom Section */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="flex flex-col md:flex-row items-center gap-4">
                <p className="body-small text-[var(--text-muted)]">
                  © {currentYear} OnePlace Platform. All rights reserved.
                </p>
              </div>
              
              <div className="flex gap-6">
                <a href="/terms/" className="body-small text-[var(--text-muted)] hover:text-[var(--text-primary)] light-transition">
                  Terms of Service
                </a>
                <a href="/privacy/" className="body-small text-[var(--text-muted)] hover:text-[var(--text-primary)] light-transition">
                  Privacy Policy
                </a>
                <a href="/privacy/#cookies-and-similar-technologies" className="body-small text-[var(--text-muted)] hover:text-[var(--text-primary)] light-transition">
                  Cookie Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
